export default __webpack_public_path__ + "static/media/fileEdit.020e5430.svg";